import { AgreementProps } from "@/entities/agreement/model/types";
import { LoanStatuses } from "@/entities/loan/model/types";
import { MediationProps } from "@/entities/mediation/model/types";
import { PaymentProps } from "@/entities/payment/model/types";

export enum CabinetStatuses {
  registration_update = "registration_update",
  application = "application",
  info = "info",
  sign = "sign",
  deal = "deal",
  prolongation = "prolongation",
  repeat = "repeat",
  blocking = "blocking",
}

export interface CabinetDealProps {
  agreement?: AgreementProps;
}

export interface CabinetBlockingProps {
  expires?: string;
}

export interface CabinetRepeatProps {
  should_choose_type?: boolean;
  hasPreviouslyClosedAgreement?: boolean;
}

export interface CabinetRefinanceProps {
  agreement?: AgreementProps;
  amount_needed?: number;
  amount_paid?: number;
  amount_prolongation?: number;
  parent_agreement_id?: number;
}

export interface PartnersLinkProps {
  button_text: string;
  label: string;
  link: string;
}

export interface CabinetInfoProps {
  data?: PaymentProps;
  key?: LoanStatuses;
  mediation?: MediationProps;
  message?: string;
  type?: string;
  status?: number;
  status_label?: string;
  external_buttons?: PartnersLinkProps;
}

export interface CabinetRegistrationUpdateProps {
  iin: string;
}

export interface CabinetRestProps {
  promo_discount?: number;
  discount_reward?: number;
}
